module.exports = __webpack_public_path__ + "static/pcc-963f94e29150b2d059be4905d1d3f480.webm";